<template>
  <div class="reset-pwd-form">
    <el-form ref="form" :model="user" :rules="rules" label-width="100px" class="modern-form" :class="{ loading }">
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input 
          v-model="user.oldPassword" 
          placeholder="请输入旧密码" 
          type="password" 
          show-password
          class="modern-input"
        />
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input 
          v-model="user.newPassword" 
          placeholder="请输入新密码" 
          type="password" 
          show-password
          class="modern-input"
        />
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input 
          v-model="user.confirmPassword" 
          placeholder="请确认新密码" 
          type="password" 
          show-password
          class="modern-input"
        />
      </el-form-item>
      <el-form-item class="form-actions">
        <el-button 
          type="primary" 
          size="default" 
          @click="submit"
          class="action-btn save-btn"
          :loading="loading"
        >
          <svg-icon icon-class="star" class="btn-icon" />
          保存
        </el-button>
        <el-button 
          type="danger" 
          size="default" 
          @click="close"
          class="action-btn cancel-btn"
        >
          <svg-icon icon-class="exit-fullscreen" class="btn-icon" />
          关闭
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updateUserPwd } from "@/service/main/system/user";

export default {
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      loading: false,
      // 表单校验
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" },
          { pattern: /^[^<>"'|\\]+$/, message: "不能包含非法字符：< > \" ' \\ |", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true;
          updateUserPwd(this.user.oldPassword, this.user.newPassword).then(response => {
            console.log('response',response)
            this.$modal.msgSuccess("修改成功");
            // 清空表单
            this.user = {
              oldPassword: undefined,
              newPassword: undefined,
              confirmPassword: undefined
            };
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    close() {
      this.$tab.closePage();
    }
  }
};
</script>

<style lang="scss" scoped>
.reset-pwd-form {
  .modern-form {
    position: relative;
    
    // 添加加载遮罩
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 12px;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 10;
      backdrop-filter: blur(2px);
    }
    
    &.loading::after {
      opacity: 1;
      visibility: visible;
    }
    .el-form-item {
      margin-bottom: 25px;
      position: relative;
      
      .el-form-item__label {
        font-weight: 500;
        color: #333;
        font-size: 14px;
        transition: all 0.3s ease;
      }
      
      &:focus-within {
        .el-form-item__label {
          color: #667eea;
          transform: translateX(5px);
        }
      }
      
      .el-form-item__content {
        .modern-input {
          position: relative;
          
          ::v-deep .el-input__inner {
            border-radius: 12px;
            border: 2px solid #f0f0f0;
            padding: 15px 20px;
            font-size: 14px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafafa;
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
            
            &:focus {
              border-color: #667eea;
              background: white;
              box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1), inset 0 2px 4px rgba(0, 0, 0, 0.05);
              transform: translateY(-1px);
            }
            
            &:hover {
              border-color: #c0c4cc;
              background: white;
              transform: translateY(-1px);
            }
            
            &::placeholder {
              color: #999;
              font-style: italic;
              transition: all 0.3s ease;
            }
            
            &:focus::placeholder {
              opacity: 0.7;
              transform: translateX(5px);
            }
          }
          
          ::v-deep .el-input__wrapper {
            box-shadow: none;
            background: transparent;
          }
          
          // 添加输入框聚焦时的光晕效果
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 12px;
            background: linear-gradient(135deg, #667eea, #764ba2);
            opacity: 0;
            transition: opacity 0.3s ease;
            z-index: -1;
          }
          
          &:focus-within::before {
            opacity: 0.1;
          }
          
          ::v-deep .el-input__suffix {
            .el-input__suffix-inner {
              .el-input__password {
                color: #666;
                transition: all 0.3s ease;
                
                &:hover {
                  color: #667eea;
                  transform: scale(1.1);
                }
              }
            }
          }
        }
      }
    }
    
    .form-actions {
      margin-top: 40px;
      padding-top: 30px;
      border-top: 1px solid #f0f0f0;
      text-align: center;
      
      .action-btn {
        padding: 12px 30px;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 500;
        border: none;
        transition: all 0.3s ease;
        margin: 0 10px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        
        .btn-icon {
          margin-right: 6px;
          font-size: 14px;
        }
        
        &.save-btn {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
        
        &.cancel-btn {
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
          
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(255, 107, 107, 0.3);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .reset-pwd-form {
    .modern-form {
      .el-form-item {
        margin-bottom: 20px;
        
        .el-form-item__label {
          font-size: 13px;
        }
        
        .el-form-item__content {
          .modern-input {
            ::v-deep .el-input__inner {
              padding: 10px 12px;
              font-size: 13px;
            }
          }
        }
      }
      
      .form-actions {
        margin-top: 30px;
        padding-top: 20px;
        
        .action-btn {
          padding: 10px 20px;
          font-size: 13px;
          margin: 0 5px;
        }
      }
    }
  }
}
</style>
